import { NOTIFICATION } from "../shared/tagTypes";
import { baseApi } from "./base";

export const notificationApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [NOTIFICATION],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getNotifications: builder.query({
        query: (payload) => ({
          url: "/notifications/my-notifications",
          params: {
            top: payload.top,
            all: payload.true
          },
        }),
        providesTags: [NOTIFICATION],
      }),
      getUnreadNotificationCount: builder.query({
        query: () => ({
          url: "/notifications/my-notification-count"
        }),
        providesTags: [NOTIFICATION],
      }),
      readNotification: builder.mutation({
        query: (payload) => ({
          url: `/notifications/${payload.id}/read`,
          method: "POST",
        }),
        invalidatesTags: [NOTIFICATION],
      })
    }),

    overrideExisting: false,
  });

export const {
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useGetUnreadNotificationCountQuery,
  useLazyGetUnreadNotificationCountQuery,
  useReadNotificationMutation
} = notificationApi;
